import React from 'react';
import { AdminDashboard } from './pages/AdminDashboard';
export function App() {
  return <AdminDashboard data-id="element-0" />;
}